export const endpointConstants = {
    HELLO_REQUEST: "ENDPOINT_HELLO_REQUEST",
    HELLO_ERROR: "ENDPOINT_HELLO_ERROR",
    
    HELLO_SUCCESS: "ENDPOINT_HELLO_SUCCESS",
};
